import produce from 'immer';
import { AnyAction } from 'redux';
import { ACTION_NAMES } from '@crewmeister/shared/src/constants';

type V3NewsAction = {
  type: string;
  newsItemId: string | number;
  isClosed: boolean;
  result?: {
    id: string | number;
    isClosed: boolean;
  };
};

type V3NewsSliceInRedux = {
  optimisticUpdates: Record<string | number, { isClosed: boolean }>;
};

const initialState: V3NewsSliceInRedux = {
  optimisticUpdates: {},
};

/* eslint-disable no-param-reassign */
export const newsReducer = (state = initialState, action: AnyAction & V3NewsAction): V3NewsSliceInRedux =>
  produce(state, (draft: V3NewsSliceInRedux) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_UPDATE_NEWS_ITEM}_BEGIN`: {
        // Store optimistic update
        draft.optimisticUpdates[action.newsItemId] = {
          isClosed: action.isClosed,
        };
        break;
      }

      case `${ACTION_NAMES.V3_UPDATE_NEWS_ITEM}_COMMIT`: {
        // Keep the optimistic update permanently on success
        // The banner should stay hidden regardless of API response
        break;
      }

      case `${ACTION_NAMES.V3_UPDATE_NEWS_ITEM}_REVERT`: {
        // Also keep hidden on failure - user intention was to close it
        // They can refresh the page if they want to see it again
        break;
      }

      default:
        break;
    }

    return draft;
  });

export default newsReducer;
